import React from "react";
import compose from "recompose/compose";
import Card from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";
import { translate } from "react-admin";
import SupplyIcon from "@material-ui/icons/Flight";
import CardIcon from "./CardIcon";

const styles = {
  main: {
    flex: "1",
    marginLeft: "1em",
    marginTop: 20,
  },
  card: {
    overflow: "inherit",
    textAlign: "right",
    padding: 16,
    minHeight: 52,
  },
};

function amountSupplies(amount, locales) {
  if (amount !== undefined) {
    let total = 0;
    amount.forEach((supplies) => {
      total += supplies.price_incl_taxes;
    });
    return (total / 100).toLocaleString(locales, {
      style: "currency",
      currency: "EUR",
    });
  }
}

const NbOperations = ({ value, amount, header, locales }) => (
  <div style={styles.main}>
    <a href="#/supplies" style={{ textDecoration: "none" }}>
      <CardIcon Icon={SupplyIcon} bgColor="#ff9800" />
      <Card style={styles.card}>
        <Typography style={styles.title} color="textSecondary">
          {header}
        </Typography>
        <Typography variant="h4" component="h1">
          {value}
        </Typography>
        <Typography>
          Montant total : &nbsp;
          {amountSupplies(amount, locales)}
        </Typography>
      </Card>
    </a>
  </div>
);

const enhance = compose(translate);

export default enhance(NbOperations);
